import Player from '@vimeo/player';
import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'vimeo-pop-video',
    templateUrl: './vimeo-pop-video.component.html',
    styleUrls: ['./vimeo-pop-video.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class VimeoPopVideoComponent {

    @Output() public eventToStockHomeCarouselComp: EventEmitter<boolean> = new EventEmitter();

    @Input()
    public showComponent: boolean = true;

    @Input()
    public categoryName: string = 'default';

    @Input()
    public videoId: any = 76979871;

    public player = null;

    constructor() {
        /** */
    }

    public ngAfterViewInit() {
        if (this.videoId && parseInt(this.videoId, 10)) {
            this.player = new Player(`videoVimeo-${this.categoryName}`, {
                id: this.videoId,
                width: 800,
            });
        }
    }

    public async ngOnChanges(changes) {

        if (changes.showComponent.currentValue && this.player) {
            // await this.player.loadVideo(this.videoId);
            await this.player.play();
        }
    }

    public async closeComponent() {
        await this.player.unload();
        // Manda evento para o pai "stockhome-carousel"
        this.eventToStockHomeCarouselComp.emit(false);
        this.showComponent = false;
    }

}
